<button id="log-in" class="hdr-btn mr-sm-1" (click)="openSignInDialog()">
  <span>
    <i class="fa fa-unlock mr-1" aria-hidden="true"></i>
    Sign In
  </span>
</button>
